// src/diagnostics.js
(function() {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const iOSVersion = navigator.userAgent.match(/OS (\d+[_\.]\d+)/)?.[1];

  // Intercepte .some() pour logger sans bloquer
  const originalSome = Array.prototype.some;
  Array.prototype.some = function(...args) {
    if (this === undefined || this === null) {
      const error = new Error('Array.some() called on null/undefined');

      console.error('[Diagnostic] Array.some() bug detected', {
        this: this,
        thisType: typeof this,
        args: args,
        stack: error.stack,
        isIOS: isIOS,
        iOSVersion: iOSVersion,
        userAgent: navigator.userAgent,
        url: window.location.href,
        timestamp: new Date().toISOString(),
      });

      // Envoie à Sentry avec contexte
      if (window.Sentry) {
        window.Sentry.withScope((scope) => {
          scope.setTag('bug_type', 'valid_domains_some');
          scope.setTag('ios_version', iOSVersion);
          scope.setContext('diagnostic', {
            thisValue: String(this),
            thisType: typeof this,
            callerStack: error.stack,
            url: window.location.href,
          });
          window.Sentry.captureException(error);
        });
      }

      // Laisse crasher pour voir le vrai stack
      return originalSome.apply(this, args);
    }
    return originalSome.apply(this, args);
  };

  // Log tous les scripts chargés
  if (isIOS) {
    window.addEventListener('load', () => {
      const scripts = Array.from(document.querySelectorAll('script[src]'))
        .map(s => s.src);
      console.info('[Diagnostic] Scripts loaded on iOS:', scripts);
    });
  }

  console.info('[Diagnostic] Monitoring enabled', { isIOS, iOSVersion });
})();

export {};
